import Vue from 'vue';

export default {
    validate (state, stepName) {
        let errors = {};

        if (!state.model.deliveryId) {
            errors['deliveryId'] = 'Выберите способ доставки';
        }

        const requiredFields = [
            'name',
            'surName',
            'email',
            'phone',
            'locationCode',
            'street',
            'house'
        ];

        requiredFields.forEach((fieldName) => {
           if (!state.model[fieldName]) {
               //errors[fieldName] = 'Заполните поле ' + fieldName;
               errors['field'] = 'Заполните обязательные поля';
           }
        });

        if (stepName === 'final') {
            if (!state.model.paysystemId) {
                errors['paysystemId'] = 'Выберите способ оплаты';
            }
        }

        Vue.set(state, 'errors', errors);

        return  Object.keys(state.errors).length === 0;
    }
}